"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.changeLogin = changeLogin;
var _action_types = require("../../constants/action_types");
var _flow = require("../flow");
var _authentication = require("../authentication");
function changeLogin(login) {
  return (dispatch, getState) => {
    dispatch({
      type: _action_types.LOGIN_CHANGE_LOGIN_TYPE,
      login
    });
    const {
      activeFlow,
      authentication: {
        password
      }
    } = getState();
    if (activeFlow) {
      dispatch((0, _flow.changeFlow)(null));
      if (password !== '') {
        dispatch((0, _authentication.changePassword)(''));
      }
    }
  };
}